module.exports = __webpack_public_path__ + "media/images/product-banners/essentials-7971a0d43eb15cecae5eb30e3b18274e.svg";